<swiper-container
    immoSwiper
    [theme]="theme()"
    [options]="options()"
    (swiperInit)="swiperInit.emit($event)"
    (slideChange)="slideChange.emit($event)"
    (activeIndexChange)="activeIndexChange.emit($event)"
    (reachBeginning)="reachBeginning.emit($event)"
    (reachEnd)="reachEnd.emit($event)">
    @for (slide of slides(); track slide) {
        <swiper-slide>
            <ng-container [ngTemplateOutlet]="slide.templateRef" [ngTemplateOutletContext]="{ $implicit: $index }" />
        </swiper-slide>
    }

    <ng-content />
</swiper-container>
